import axios from "./index";

export default {
  getDropdown() {
    return axios.get("/v1/setting/regions/dropdown");
  },
};
